/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_No_CoverInputs */

const cs_blog_no_cover = /** @type {(inputs: Blog_No_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez úvodního obrázku`)
};

const en_blog_no_cover = /** @type {(inputs: Blog_No_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cover image`)
};

/**
* | output |
* | --- |
* | "No cover image" |
*
* @param {Blog_No_CoverInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_no_cover = /** @type {((inputs?: Blog_No_CoverInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_No_CoverInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_no_cover(inputs)
	return cs_blog_no_cover(inputs)
});